import { smartypants } from "smartypants"
import widont from "widont"

const formatTypography = (text) => {
  if (!text) return null
  return widont(smartypants(text))
}

export default formatTypography
